import {
  GET_CATEGORIES,
  GET_CITIES,
  GET_GENRE,
  GET_SHOWS,
  GET_STATES,
  GET_RBAC,
} from "../store/actions/ActionTypes";
import { get } from "../store/actions/CommonActions";
import { GET_COUNTRIES } from "../store/actions/CountryTypes";
import { GET_INITIATIVE } from "../store/actions/InitiativeTypes";
import { GET_PERFORMANCE_VENUE } from "../store/actions/PerformanceVenueTypes";
import { GET_VENUE } from "../store/actions/VenueTypes";

export const getCountries = (data) => {
  return (dispatch) => {
    dispatch(get("master/countries", data, GET_COUNTRIES));
  };
};

export const getStates = (data) => {
  return (dispatch) => {
    dispatch(get("master/states", data, GET_STATES));
  };
};

export const getCities = (data) => {
  return (dispatch) => {
    dispatch(get("master/cities", data, GET_CITIES));
  };
};

export const getVenues = (data) => {
  return (dispatch) => {
    dispatch(get("venue", data, GET_VENUE));
  };
};

export const getPerformanceVenues = (data) => {
  return (dispatch) => {
    dispatch(get("performanceVenue", data, GET_PERFORMANCE_VENUE));
  };
};

export const getCategories = (data) => {
  return (dispatch) => {
    dispatch(get("master/categories", data, GET_CATEGORIES));
  };
};

export const getGenre = (data) => {
  return (dispatch) => {
    dispatch(get("master/genre", data, GET_GENRE));
  };
};

export const getRbac = (data) => {
  return (dispatch) => {
    dispatch(get("rbac", data, GET_RBAC));
  };
};

export const getInitiatives = (data) => {
  return (dispatch) => {
    dispatch(get("initiative", data, GET_INITIATIVE));
  };
};
